export const visitorScopeGroupCodes = [
  'visitorAdmin',
  'visitorIntegration',
  'visitorConfigurations',
  'visitorAlertSettings',
  'visitorLocation',
  'visitorUser',
  'visitorInvitation',
  'visitorSigninConf',
  'visitorSignoutConf',
  'visitorKiosk',
  'visitorAgreements',
  'visitorRedflagConf',
  'visitorFields',
  'visitorEmailTemplates',
  'visitorDash',
  'visitorVisitors',
  'visitorInvite',
  'visitorAllVisitors',
  'visitorVisitorLog',
  'visitorSignIn',
  'visitorSignOut',
  'visitorDeny',
  'visitorRedFlag',
  'visitorGuestPass',
  'visitorVisitorsBulk',
  'visitorRpt',
  'visitorRptVisitor',
  'visitorRptTrend',
  'visitorRptRedFlag',
  'visitorRptHost',
  'visitorRptActivity',
  'visitorRptGuestPass',
] as const;

export type VisitorScopeGroupCode = (typeof visitorScopeGroupCodes)[number];

export const visitorScopeTemplates = visitorScopeGroupCodes.flatMap(
  (scopeGroup) => [`o{orgId}-${scopeGroup}:r`, `o{orgId}-${scopeGroup}:w`],
);

export const getVisitorScopesForOrg = (orgId?: number | string | null) =>
  visitorScopeGroupCodes.flatMap((scopeGroup) => [
    `o${orgId}-${scopeGroup}:r`,
    `o${orgId}-${scopeGroup}:w`,
  ]);
